import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../../Store';
import ModuleHueSettings, { Props } from '../_components/ModuleHueSettings';
import { ModuleOnValueUpdate } from '../../_actions/ModuleActions';

const mapStateToProps = (store:Store, props:Props) => ({
	hue: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'hue'])
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	onHueChange: (value) => dispatch(ModuleOnValueUpdate(props.moduleId, 'hue', Number(value))),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ModuleHueSettings);